import React, { useState } from 'react';
import { Modal } from 'reactstrap';
  import _ from 'lodash'
  import Actions from '../../../appFlux/action'
import { SelectDD , ExternalDD } from '../../../common/dropdowns';

const genderList = [ 
    { value: 'Female', label: 'Female' },
    { value: 'Male', label: 'Male' },
    { value: 'Others', label: 'Others' }
  ]
const statusList = [ 
    { value: 'Single', label: 'Single' },
    { value: 'Married', label: 'Married' },
]

const genLVList = (list) => {
    return list.map(o => {return {value: o, label: o}})
}

class EditMyPersonalInfoModal extends React.Component {
    constructor(props) {
        super(props);
        var { modal, toggle, personalInfo } = props
        this.state = {
            personalInfo: _.cloneDeep(personalInfo),
            languageFullSet: ["English","Hindi","Bengali","Urdu","Punjabi","Marathi","Telugu","Tamil","Gujarati","Kannada","Odia","Malayalam","Santali","Sanskrit"]
        }
    }

    setPersonalInfo = (value, param) => {
        var { personalInfo, index } = this.state
        personalInfo[param] = value
        console.log(personalInfo)
        this.setState({personalInfo})
    }

    reset = () => this.setState({personalInfo: _.cloneDeep(this.props.personalInfo)})
    save = () => {
        Actions.setPersonalInfo(this.state.personalInfo)
        this.props.toggle()
    }

    creatableOption = (selected, param) => {
        if(selected.length > 3) return
        var created = selected.filter(o => o.__isNew__)[0]
        selected = selected.map(o => o.value)
        var { languageFullSet , personalInfo } = this.state
        if(created) languageFullSet.push(created.value)
        personalInfo.languages = selected // This should be a service call
        console.log(created, languageFullSet)
        this.setState({languageFullSet, personalInfo })
    }

    render() {
        var { modal, toggle } = this.props
        var { personalInfo, languageFullSet } = this.state
        
        var selectedGender = genderList.filter(o => o.value == personalInfo.gender)[0]
        var selectedStatus = statusList.filter(o => o.value == personalInfo.status)[0]
        var languageList = genLVList(languageFullSet)
        var languageSelected = languageList.filter(o => personalInfo.languages.includes(o.value))

        return (
            <Modal isOpen={modal} toggle={toggle} className="modal-wrap wd-800">        
            <div className="pd-t-20 pd-r-20 pd-l-20 pd-b-10 v-align box-shadow" >
                <div className="modal-header">Edit Personal Information</div>
                <div className="v-align f-right" style={{marginLeft:'auto'}}>
                    <i className="fa fa-cog modal-close mg-r-15" ></i>
                    <i className="far fa-question-circle modal-close mg-r-15" ></i>            
                    <i className="fas fa-times modal-close" onClick={toggle}></i>
                </div>
            </div>   
            <hr className="mg-r-0"></hr>
            <div className="modal-block">
                <div className="row mg-b-15">
                    <div className="col-md-6">
                        <div className="modal-subheader">Gender</div>
                        <SelectDD data={genderList} onChange={(o) => this.setPersonalInfo(o.value, "gender")} selected={selectedGender} isClearable={false} />
                    </div>
                    <div className="col-md-6">
                        <div className="modal-subheader">Marital Status</div>
                        <SelectDD data={statusList} onChange={(o) => this.setPersonalInfo(o.value, "status")} selected={selectedStatus} isClearable={false} />
                    </div>
                </div>
                <div className="row mg-b-15">
                    <div className="col-md-6">
                        <div className="modal-subheader">Languages Known (max 3)</div>
                        <SelectDD data={languageList} onChange={(o) => this.creatableOption(o, "languages")} selected={languageSelected} creatable={true} isClearable={true} isMulti={true}/>
                    </div>
                    <div className="col-md-6">
                        <div className="modal-subheader">Valid Visa</div>
                        <div><input value={personalInfo.visa} onChange={(e) => this.setPersonalInfo(e.target.value, "visa")} type="text" className="form-control"></input></div>
                    </div>
                </div>
                <div>
                    <div className="checkbox-fade fade-in-primary mg-b-10">
                        <label>
                            <input type="checkbox" checked={personalInfo.stateReallocate} onChange={() => this.setPersonalInfo(!personalInfo.stateReallocate, "stateReallocate")}></input>
                            <span className="cr">
                                <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                            </span>
                            <span >I can reallocate to a different state</span>
                        </label>
                    </div> 
                    </div>
                <div>
                    <div className="checkbox-fade fade-in-primary mg-b-10">
                        <label>
                            <input type="checkbox" checked={personalInfo.countryReallocate} onChange={() => this.setPersonalInfo(!personalInfo.countryReallocate, "countryReallocate")}></input>
                            <span className="cr">
                                <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                            </span>
                            <span >I can reallocate to a different country</span>
                        </label>
                    </div>  
                </div>
                <div>
                    <div className="checkbox-fade fade-in-primary mg-b-10">
                        <label>
                            <input type="checkbox" checked={personalInfo.workFromHome} onChange={() => this.setPersonalInfo(!personalInfo.workFromHome, "workFromHome")}></input>
                            <span className="cr">
                                <i className="cr-icon icofont icofont-ui-check txt-primary"></i>
                            </span>
                            <span >I can work from home</span>
                        </label>
                    </div> 
                </div> 
            </div> 
            <hr className="mg-0 "></hr>
            <div className="pd-20 box-shadow-top">
                <button className="btn btn-danger-lite f-right " onClick={toggle}>Cancel</button>
                <button className="btn btn-primary-lite f-right mg-r-15" onClick={this.save}>Save</button>
                <button className="btn btn-success-lite mg-r-15 f-right" onClick={this.reset}>Reset</button>   
            </div>    
        </Modal>
        )
    }
}
export default EditMyPersonalInfoModal;